import React, { useEffect, useState } from 'react'
import { Button, Spinner, Row, Col, Form, Badge } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RequiredLabel } from '../utils/validators';
import { createSubConcepts, getConcepts } from '../services/Concepts';

function AddSubConcept() {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();

  // CONCEPTOS
  const [concepts, setConcepts] = useState([]);
  const [conceptId, setConceptId] = useState('');

  useEffect(() => {
    (async () => {
      const list = await getConcepts();
      setConcepts((list || []).filter(x => x.isActive));
    })();
  }, []);

  const redirectBack = () => navigate(`/subconcepts`);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return toast.warn('El nombre es requerido');

    try {
      setIsSaving(true);
      if (!conceptId) return toast.warn('Selecciona un concepto');
      await createSubConcepts({ name, concept_id: Number(conceptId) });
      toast.success('Subconcepto creado');
      navigate('/subconcepts');
    } catch (err) {
      console.error(err);
      toast.error('No se pudo crear el subconcepto');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <Spinner animation="border" role="status" />
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formConceptName" className="mb-3">
            <Form.Label as={RequiredLabel} required>Nombre:</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ej. Cobertura"
              maxLength={350}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label as={RequiredLabel} required>Concepto:</Form.Label>
            <Form.Select value={conceptId} onChange={(e) => setConceptId(e.target.value)}>
              <option value="">Selecciona...</option>
              {concepts.map(c => (
                <option key={c.id} value={c.id}>{c.description}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <Row>
            <Col xl={12} className='text-center'>
              <Button className='m-3' variant="secondary" type="button" onClick={redirectBack} disabled={isSaving}>
                Cancelar o regresar
              </Button>
              <Button className='m-3' variant="primary" type="submit" disabled={isSaving}>
                {isSaving ? 'Guardando...' : 'Crear subconcepto'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
      <ToastContainer />
    </div>
  );
}

export default AddSubConcept;